import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import Loader from "../libs/loader.jsx";


import { Button, Heading, TextField, Tooltip } from "monday-ui-react-core";
import { Duplicate, Retry } from "monday-ui-react-core/dist/allIcons";

class Documentation extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log(this.props);
        //this.params = this.props.router.params;
        
        this.page = 0;
        
        var page = this.props.router.search.get('page');
        if( page !== null ) this.page = page;
        
        this.state = {
        };
        
        this.props.menu.activateTab('documentation');
        
        this.loader = React.createRef();
    }
    
    componentDidMount()
    {
        var this_component = this;
    }
    
    render()
    {
        var this_component = this;
        
        return (
            <Loader ref={this_component.loader} style={{'height': '100%', 'display': 'flex', 'flexFlow': 'column'}}>
                <div>
                    <Heading type={Heading.types.h2} value="Documentation" customColor="var(--primary-text-color)" />
                </div>
                
                <div style={{ 'height': '100%' }}>
                    <iframe src={'/pdf/PBCFMC-Documentation.pdf#page='+this_component.page} width="100%" height="100%">
                    </iframe>
                </div>

            </Loader>
        );
    }
    
}

Documentation.defaultProps = {
};

export default withRouter(Documentation);
